import React, { useCallback, useEffect } from 'react'

import { useLocation, useNavigate } from 'react-router-dom'
import InterWebviewBridge, { interWbNavigate } from 'inter-webview-bridge'

export const GoBackProvider = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const iWb = InterWebviewBridge.getInstance()

  const listenerMobileBack = useCallback(() => {
    if (location?.pathname === '/') {
      interWbNavigate.requestGoBack()
    } else {
      navigate(-1)
    }
  }, [navigate, location])

  useEffect(() => {
    iWb.addBackListener(listenerMobileBack)
    return () => {
      iWb.removeBackListener(listenerMobileBack)
    }
  }, [iWb, listenerMobileBack])

  return <> </>
}
